import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tableThActionFn = /* @__PURE__ */ createRecipe('table-th-action', {}, [])

const tableThActionVariantMap = {}

const tableThActionVariantKeys = Object.keys(tableThActionVariantMap)

export const tableThAction = /* @__PURE__ */ Object.assign(memo(tableThActionFn.recipeFn), {
  __recipe__: true,
  __name__: 'tableThAction',
  __getCompoundVariantCss__: tableThActionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tableThActionVariantKeys,
  variantMap: tableThActionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tableThActionVariantKeys)
  },
  getVariantProps: tableThActionFn.getVariantProps,
})